import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import adminService from '../../services/adminService';
import productService from '../../services/productService'; 
import styles from './AdminStoryEditor.module.scss';
import { toast } from 'react-toastify';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import MediaLibraryModal from '../../components/common/MediaLibraryModal/MediaLibraryModal';
import BlotFormatter from 'quill-blot-formatter';

// 1. Đăng ký Module ảnh
Quill.register('modules/blotFormatter', BlotFormatter);

// 2. Đăng ký Font Size
const Size = Quill.import('attributors/style/size');
const fontSizeArr = [
  '12px', '13px', '14px', '15px', '16px', '18px', '20px', '24px', '28px', '32px', '36px', '48px', '64px'
];
Size.whitelist = fontSizeArr;
Quill.register(Size, true);

const BACKEND_URL = 'https://huongtramcomoc.vn';
const PAGE_SLUG = 'cau-chuyen-tram';

const AdminStoryEditor = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const quillRef = useRef(null);

  useEffect(() => {
    productService.getPageContent(PAGE_SLUG).then(res => {
      if(res.data) {
        setTitle(res.data.title || '');
        setContent(res.data.content || '');
      }
    }).catch(err => console.error(err));
  }, []);

  const imageHandler = useCallback(() => setIsModalOpen(true), []);

  const handleFileSelect = (file) => {
    const editor = quillRef.current.getEditor();
    const range = editor.getSelection(true);
    const cursorPosition = range ? range.index : editor.getLength();
    const imageUrl = `${BACKEND_URL}${file.file_path}`;
    editor.insertEmbed(cursorPosition, 'image', imageUrl);
    editor.setSelection(cursorPosition + 1);
    setIsModalOpen(false);
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, 4, 5, false] }],
        [{ 'size': fontSizeArr }], 
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['blockquote'], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['link', 'image', 'video'],
        ['clean'] 
      ],
      handlers: { image: imageHandler }
    },
    blotFormatter: { overlay: { style: { border: '2px solid #bfa070' } } },
    clipboard: { matchVisual: false }
  }), [imageHandler]);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'indent', 'link', 'image', 'video',
    'color', 'background', 'align'
  ];

  const handleSave = () => {
    setLoading(true);
    adminService.updatePageContent(PAGE_SLUG, title, content)
      .then(() => toast.success("Đã lưu nội dung thành công!"))
      .catch(err => toast.error("Lỗi: " + err.message))
      .finally(() => setLoading(false));
  };

  return (
    <div className={styles.adminPage}>
      <div className={styles.header}>
        <h1>Biên Tập: Câu Chuyện Trầm</h1>
        <button onClick={handleSave} className={styles.saveBtn} disabled={loading}>
          {loading ? 'Đang Lưu...' : 'Lưu Thay Đổi'}
        </button>
      </div>
      <div className={styles.inputGroup}>
        <label>Tiêu đề trang (H1)</label>
        <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Nhập tiêu đề chính..." />
      </div>
      <div className={styles.editorContainer}>
        <label>Nội dung chi tiết</label>
        <p style={{fontSize: '0.9rem', color: '#555', marginBottom: '15px', background: '#eef', padding: '10px', borderRadius: '4px'}}>
          <b>💡 Tính năng Ẩn/Hiện ảnh:</b> Bôi đen dòng chữ muốn làm nút bấm, chèn Link là <b>#toggle-images</b>. Sau đó chèn các ảnh cần ẩn ngay bên dưới dòng đó.
        </p>
        <div className={styles.quillWrapper}>
          <ReactQuill 
            ref={quillRef} theme="snow" value={content} onChange={setContent}
            modules={modules} formats={formats} placeholder="Viết câu chuyện của bạn..."
          />
        </div>
      </div>
      <MediaLibraryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onFileSelect={handleFileSelect} />
    </div>
  );
};

export default AdminStoryEditor;